const shopLink = (params = "") => `/shop${params ? `?${params}` : ""}`;

export const siteConfig = {
  brandName: "Armelvari",
  logo: {
    type: "wordmark",
    wordmark: "Armelvari",
    ariaLabel: "Armelvari home",
  },
  description:
    "Contemporary clothing made with more responsible materials, transparent partnerships and a commitment to lasting design.",
  locale: "en-US",
  currency: {
    code: "USD",
    symbol: "$",
    label: "United States (USD)",
  },
  contact: {
    email: "courier@armelvari.shop",
    hours: "Monday–Friday, 9am–5pm CET",
    address: "Thebäerstraße 17, 50823 Cologne, Germany",
  },
  commerce: {
    shippingCost: 15,
    freeShippingThreshold: 250,
    discountCode: "CHANGE10",
    discountRate: 0.1,
    returnWindowDays: 30,
    shippingEstimate: "5–10 business days",
  },
  announcements: [
    {
      label: "10% OFF YOUR FIRST ORDER — JOIN OUR NEWSLETTER",
      href: "/#newsletter",
    },
    { label: "4.5 ★ FROM 30,000+ REVIEWS", href: "/about#impact" },
    { label: "WELCOME TO Armelvari — GET HELP", href: "/contact" },
  ],
  navigation: [
    {
      label: "Women",
      href: shopLink("gender=women"),
      columns: [
        {
          title: "Discover",
          links: [
            {
              label: "New arrivals",
              href: shopLink("gender=women&sort=newest"),
            },
            {
              label: "Iconic Å favorites",
              href: shopLink("gender=women&tag=iconic"),
            },
            {
              label: "Bestsellers",
              href: shopLink("gender=women&sort=bestseller"),
            },
            { label: "Shop all women", href: shopLink("gender=women") },
          ],
        },
        {
          title: "Clothing",
          links: [
            {
              label: "T-Shirts & tops",
              href: shopLink("gender=women&category=tops"),
            },
            { label: "Jeans", href: shopLink("gender=women&category=jeans") },
            { label: "Pants", href: shopLink("gender=women&category=pants") },
            { label: "Shorts", href: shopLink("gender=women&category=shorts") },
            { label: "Favorites", href: shopLink("gender=women&tag=favorite") },
            { label: "All clothing", href: shopLink("gender=women") },
          ],
        },
        {
          title: "Jeans fits",
          links: [
            {
              label: "Wide",
              href: shopLink("gender=women&category=jeans&fit=wide"),
            },
            {
              label: "Mom",
              href: shopLink("gender=women&category=jeans&fit=mom"),
            },
            {
              label: "Barrel",
              href: shopLink("gender=women&category=jeans&fit=barrel"),
            },
            {
              label: "Slim",
              href: shopLink("gender=women&category=jeans&fit=slim"),
            },
            {
              label: "Skinny",
              href: shopLink("gender=women&category=jeans&fit=skinny"),
            },
          ],
        },
      ],
      feature: {
        eyebrow: "WOMEN'S DENIM",
        title: "Find your fit",
        description:
          "Wide, straight, barrel and relaxed fits designed for everyday movement.",
        href: shopLink("gender=women&category=jeans"),
        linkLabel: "Explore denim",
      },
    },
    {
      label: "Men",
      href: shopLink("gender=men"),
      columns: [
        {
          title: "Discover",
          links: [
            { label: "New arrivals", href: shopLink("gender=men&sort=newest") },
            {
              label: "Iconic Å favorites",
              href: shopLink("gender=men&tag=iconic"),
            },
            {
              label: "Bestsellers",
              href: shopLink("gender=men&sort=bestseller"),
            },
            { label: "Shop all men", href: shopLink("gender=men") },
          ],
        },
        {
          title: "Clothing",
          links: [
            {
              label: "T-Shirts",
              href: shopLink("gender=men&category=t-shirts"),
            },
            { label: "Jeans", href: shopLink("gender=men&category=jeans") },
            { label: "Shirts", href: shopLink("gender=men&category=shirts") },
            { label: "Pants", href: shopLink("gender=men&category=pants") },
            { label: "Sweats", href: shopLink("gender=men&category=sweats") },
            { label: "Jackets", href: shopLink("gender=men&category=jackets") },
          ],
        },
        {
          title: "More to explore",
          links: [
            {
              label: "Knitwear",
              href: shopLink("gender=men&category=knitwear"),
            },
            { label: "Iconic Å", href: shopLink("gender=men&tag=iconic") },
            { label: "Favorites", href: shopLink("gender=men&tag=favorite") },
            { label: "Shop all men", href: shopLink("gender=men") },
          ],
        },
      ],
      feature: {
        eyebrow: "MEN'S EDIT",
        title: "Everyday, considered",
        description:
          "Clean layers, relaxed tailoring and denim made for repeat wear.",
        href: shopLink("gender=men&sort=newest"),
        linkLabel: "Shop the edit",
      },
    },
    {
      label: "DetoxDenim",
      href: shopLink("category=jeans"),
      columns: [
        {
          title: "Women's fits",
          links: [
            {
              label: "Wide",
              href: shopLink("gender=women&category=jeans&fit=wide"),
            },
            {
              label: "Mom",
              href: shopLink("gender=women&category=jeans&fit=mom"),
            },
            {
              label: "Barrel",
              href: shopLink("gender=women&category=jeans&fit=barrel"),
            },
            {
              label: "Straight",
              href: shopLink("gender=women&category=jeans&fit=straight"),
            },
          ],
        },
        {
          title: "Men's fits",
          links: [
            {
              label: "Tapered",
              href: shopLink("gender=men&category=jeans&fit=tapered"),
            },
            {
              label: "Relaxed",
              href: shopLink("gender=men&category=jeans&fit=relaxed"),
            },
            {
              label: "New denim",
              href: shopLink("gender=men&category=jeans&sort=newest"),
            },
            { label: "All jeans", href: shopLink("gender=men&category=jeans") },
          ],
        },
        {
          title: "Inspiration",
          links: [
            { label: "DetoxDenim explained", href: "/about" },
            { label: "Materials", href: "/about" },
            { label: "Care guide", href: "/about" },
          ],
        },
      ],
      feature: {
        eyebrow: "DETOXDENIM",
        title: "Denim, rethought",
        description:
          "Lower-impact materials, considered washes and fits built to last.",
        href: shopLink("category=jeans"),
        linkLabel: "Shop all denim",
      },
    },
    { label: "Mission", href: "/about" },
  ],
  footerNavigation: [
    {
      title: "Shop",
      links: [
        { label: "Women", href: shopLink("gender=women") },
        { label: "Men", href: shopLink("gender=men") },
        { label: "New arrivals", href: shopLink("sort=newest") },
        { label: "Denim", href: shopLink("category=jeans") },
      ],
    },
    {
      title: "About us",
      links: [
        { label: "Our mission", href: "/about" },
        { label: "Materials", href: "/about#materials" },
        { label: "Impact", href: "/about#impact" },
        { label: "Contact", href: "/contact" },
      ],
    },
    {
      title: "Help",
      links: [
        { label: "Shipping", href: "/shipping" },
        { label: "Returns", href: "/returns" },
        { label: "Contact us", href: "/contact" },
        { label: "Shopping bag", href: "/cartpage" },
      ],
    },
  ],
  legalNavigation: [
    { label: "Privacy", href: "/privacy" },
    { label: "Terms & conditions", href: "/terms" },
    { label: "Returns policy", href: "/returns" },
    { label: "Shipping policy", href: "/shipping" },
  ],
  newsletter: {
    eyebrow: "CHANGEMAKERS CLUB",
    title: "SIGN UP FOR OUR NEWSLETTER AND RECEIVE 10% OFF.",
    description:
      "Be first to hear about new products, responsible materials and stories from our community.",
    consent: "I agree to receive product news and offers by email.",
  },
};

export default siteConfig;
